import React from 'react'

import useOpenJumpInfo from '../lib/use-open-jump-info'

/**
 * The current Open Jump price, e.g. "$15/child".
 * Renders the bare string so callers keep their own punctuation.
 */
const OpenJumpPrice = () => {
  const { price } = useOpenJumpInfo()

  return <>{price}</>
}

export default OpenJumpPrice
